import React, { Component } from 'react'
import { Container } from './password.style'
import { ErrorMessage, getIn } from 'formik'

class PasswordComponent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			invalid: false
		}
	}

	countCharacters = e => {
		const re = /^[0-9\b]+$/

		if (e.target.value.length > 3) {
			if (!re.test(this.props.values.password)) {
				if (!this.props.errors.password) {
					this.setState({ invalid: true })
				}
			} else {
				this.props.nextStep(this.props.step)
			}
		} else {
			this.setState({ invalid: false })
		}
	}

	clear = () => {
		this.props.setFieldValue('password', '', true)
	}

	back = step => {
		this.props.prevStep(step)
	}

	render() {
		const { handleChange, errors, handleBlur, step } = this.props
		const { password } = this.props.values
		return (
			<Container>
				<header>
					<h2>Redefina sua senha</h2>
				</header>

				<div>
					<input
						min="0"
						inputmode="numeric"
						autoFocus
						type="password"
						maxLength="4"
						autoComplete="off"
						name="password"
						pattern="[0-9]*"
						placeholder="****"
						id="password"
						value={password}
						onChange={handleChange}
						onBlur={handleBlur}
						onKeyUp={e => this.countCharacters(e)}
					/>

					{this.state.invalid ? (
						<div className="msg-error">
							Deve conter apenas caracteres numéricos
						</div>
					) : (
						<ErrorMessage
							component="div"
							name="password"
							className="msg-error"
						/>
					)}
				</div>

				<footer className="footer">
					<button
						className="button"
						type="button"
						onClick={() => this.back(step)}>
						Voltar
					</button>
					<button
						className="button transparent"
						type="reset"
						onClick={() => this.clear()}>
						Limpar
					</button>
				</footer>
			</Container>
		)
	}
}

export default PasswordComponent
